export default {
  common: {
    duplicate: {
      notes: 'Title of generic ecom duplicate action',
      message: 'Duplicate',
    },
  },
};
